export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://analytics.omattic.com'
export const AUTH_SERVICE_URL = 'https://auth.omattic.com'

export const DATE_RANGES = {
  '7d': { label: 'Last 7 days', days: 7 },
  '30d': { label: 'Last 30 days', days: 30 },
  '90d': { label: 'Last 90 days', days: 90 },
  '1y': { label: 'Last year', days: 365 },
  custom: { label: 'Custom range', days: 0 },
} as const

export const CHART_COLORS = {
  primary: 'hsl(221.2 83.2% 53.3%)',
  secondary: 'hsl(210 40% 96.1%)',
  success: 'hsl(142.1 76.2% 36.3%)',
  warning: 'hsl(45.4 93.4% 47.5%)',
  danger: 'hsl(346.8 77.2% 49.8%)',
  visitors: 'hsl(221.2 83.2% 53.3%)',
  pageviews: 'hsl(142.1 76.2% 36.3%)',
}

export const REFRESH_INTERVAL = 30000 // 30 seconds for real-time data
